import { Link } from 'react-router-dom'
import { Button, Card, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const FinancialReportsCard = ({ userId }: { userId: number }) => (
  <Card className="w-full">
    <Text variant={TypographyStyles.H2}>Financial Reports</Text>
    <br />
    <Link
      to={`/admin/finances/financial-reports/${userId}/profit-loss`}
      className="flex justify-end"
    >
      <Button variant="link">User Profit and Loss &gt;&gt;&gt;</Button>
    </Link>
    <Link
      to={`/admin/finances/financial-reports/${userId}/profit-loss?confirmed=true`}
      className="flex justify-end"
    >
      <Button variant="link">Journal Entry Profit and Loss &gt;&gt;&gt;</Button>
    </Link>
    <Link
      to={`/admin/finances/financial-reports/${userId}/general-ledger`}
      className="flex justify-end"
    >
      <Button variant="link">User General Ledger &gt;&gt;&gt;</Button>
    </Link>
    <Link
      to={`/admin/finances/financial-reports/${userId}/general-journal`}
      className="flex justify-end"
    >
      <Button variant="link">User General Journal &gt;&gt;&gt;</Button>
    </Link>
    <Link
      to={`/admin/finances/financial-reports/${userId}/balance-sheet`}
      className="flex justify-end"
    >
      <Button variant="link">Balance Sheet &gt;&gt;&gt; </Button>
    </Link>
    <Link
      to={`/admin/finances/financial-reports/${userId}/auto-balance-sheet`}
      className="flex justify-end"
    >
      <Button variant="link">Auto-Generated Balance Sheet &gt;&gt;&gt;</Button>
    </Link>
  </Card>
)
